import React from "react";
const year = new Date().getFullYear();
export const Footer = () => {
  return (
    <>
      <div
        className="container-fluid app-bg-dark"
        style={{ paddingTop: "15px", paddingBottom: "15px" }}
      >
        <div className="row align-items-center justify-content-between row-gap-3">
          <div className="col-md-4 footer-logo-container">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
              style={{ height: "33.19px", width: "198px" }}
              alt=""
            />
          </div>
          <div className="col-md-4 text-center text-md-end text-white">
            <span style={{ fontSize: "15px" }} className="text-center">
              <a
                href="mailto:support@jabchaho.com"
                style={{ color: "inherit", textDecoration: "inherit" }}
              >
                support@jabchaho.com
              </a>{" "}
              |{" "}
              <a
                href="tel:+9221111524246"
                style={{ color: "inherit", textDecoration: "inherit" }}
              >
                +9221-111-524-246
              </a>
            </span>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row" style={{ padding: "8px 0px" }}>
          <div className="col-12 footer-text-container text-center">
            <span style={{ color: "#A2A2A6", fontSize: "14px" }}>
              © {year}. JabChaho Laundry Services.{" "}
              <span className="d-block d-md-inline">All Rights Reserved.</span>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
